import React from 'react';
import { SearchBox } from '@fluentui/react-components';
import { GuideDrawer } from '../../../../../../theme/components/GuideDrawer';
import { GuideField } from '../../../../../../theme/components/GuideField';
import ProtocolSelectorComponent from '../../../../../../commons/component/Inputs/ProtocolSelector/ProtocolSelectorComponent';
import { CurrencySelectorComponent } from '../../../../../../commons/component/Inputs/CurrencySelector/CurrencySelectorComponent';
import ProtocolConsumptionStatusSelectorComponent from '../../../../../../commons/component/Inputs/ProtocolConsumptionStatusSelector/ProtocolConsumptionStatusSelector.Component';
import { Protocol } from '../../../../../../models/Entities/Protocols/Protocol';
import { IConsumptionStatusProps } from '../../../../../../commons/component/Inputs/ProtocolConsumptionStatusSelector/ProtocolConsumptionStatusSelector.Functions';
import DateRangeSelectorComponent from '../../../../../../commons/component/Inputs/DateRangeSelector/DateRangeSelector.Component';
import { IConsumptionsFilters } from '../../../../../../models/Filters/ConsumptionsFilters';

interface Props {
  isOpen: boolean;
  Filters: IConsumptionsFilters;
  onClose: () => void;
  onFilterChange: (filters: IConsumptionsFilters) => void;
}

const PractitionerFilterPanelComponent = (props: Props) => {
  const { isOpen, Filters, onClose, onFilterChange } = props;
  const [filterText, setFilterText] = React.useState<string>(Filters.FilterText ?? '');
  const [selectedProtocols, setSelectedProtocols] = React.useState<Protocol[]>(Filters.SelectedProtocols ?? []);
  const [selectedCurrency, setSelectedCurrency] = React.useState<string>(Filters.SelectedCurrencys ?? '');
  const [selectedStatus, setSelectedStatus] = React.useState<IConsumptionStatusProps[]>(Filters.SelectedStatus ?? []);
  const [startDate, setStartDate] = React.useState<Date | undefined>(Filters.SelectedDateRange[0] ?? undefined);
  const [endDate, setEndDate] = React.useState<Date | undefined>(Filters.SelectedDateRange[1] ?? undefined);

  const handleDateChange = (start: Date | undefined, end: Date | undefined) => {
    setStartDate(start);
    setEndDate(end);
  };

  const handleApply = () => {
    onFilterChange({
      ...Filters,
      FilterText: filterText,
      SelectedProtocols: selectedProtocols,
      SelectedCurrencys: selectedCurrency,
      SelectedStatus: selectedStatus,
      SelectedDateRange: [startDate, endDate]      
    });
    onClose();
  };

  return (
    // Cerrar con la X, Esc o el fondo aplica los filtros (como antes); "Cancelar" cierra sin aplicar.
    <GuideDrawer
      open={isOpen}
      size="small"
      title="Filtros"
      onDismiss={handleApply}
      testId="practitioner-consumption-filter-drawer"
      secondaryAction={{ label: 'Cancelar', onClick: onClose }}
      primaryAction={{ label: 'Aplicar', onClick: handleApply }}
    >
      <GuideField label="Buscar">
        <SearchBox value={filterText} onChange={(_, data) => setFilterText(data.value)} />
      </GuideField>
      <ProtocolSelectorComponent
        selectionLimit={undefined}
        onChangeSelection={(selectedProtocols: Protocol[] | undefined) => selectedProtocols ? setSelectedProtocols(selectedProtocols) : setSelectedProtocols([])}
      />
      <GuideField label="Moneda">
        <CurrencySelectorComponent
          defaultSelected={selectedCurrency}
          onCurrencyChange={setSelectedCurrency}
          label={''}
          errorMessage={undefined}
          disabled={false}
          isRequired={false}
        />
      </GuideField>
      <ProtocolConsumptionStatusSelectorComponent
        ContractId={0}
        onSelectedStatus={setSelectedStatus}
        statusSelected={selectedStatus?.map((s: any) => s.id)}
        MultiselectEnable={true}
      />
      <GuideField label="Rango de fechas">
        <DateRangeSelectorComponent
          startDate={startDate}
          endDate={endDate}
          onDateChange={handleDateChange}
          startDateLabel={"Desde"}
          endDateLabel={"Hasta"}
          className={"ConsumptionFilterDateRangeElement"}
        />
      </GuideField>
    </GuideDrawer>
  );
};

export default PractitionerFilterPanelComponent;
